<template>
  <div>
    <ExpertStatisticsTemplate
      :periodSelector="periodSelector"
      @timeSelector="setPeriod(startDate, endDate)"
      :elements="extensions"
      :clearTimeSelector="clearTimeSelector"
      @selector="
        $emit('update:selector', $event),
          $emit('setSelector', $event),
          $store.dispatch('pbxPeriodSelected', $event)
      "
      @setPeriod="(...args) => setPeriod(...args)"
      @download-report="downloadReport()"
      :startDate="startDate"
      :endDate="endDate"
      @activeBanner="$emit('activeBanner')"
      @successMsg="$emit('successMsg', $event)"
      @success="$emit('success', $event)"
      :urlType="urlType"
      @setLoading="$emit('setLoading', $event)"
    >
      <template v-slot:selector>
        <PbxDashboardSelector
          :key="pbxElements"
          @selector="period = $event"
          @button-selector="(...args) => getSelectedButton(...args)"
          @action="
            $emit('action', $event), (selectedElement = $event), setTableData()
          "
          :selectHostname="selectHostname"
          :urlType="urlType"
          @queueName="selectedQueue = $event"
          :buttonSelected="buttonSelected"
          :elements="selectedElement"
          @timeSelector="setPeriod(startDate, endDate)"
          :groupDatesQueueReport="groupData"
        />
      </template>
      <template v-slot:content>
        <PbxHeader
          v-model:search="search"
          pbxMenuType="queueDetail"
          :periodSelector="period"
          :parseDateRange="parseDateRange"
          @select-hostname="selectHostname = $event"
          :selectedQueue="selectedQueue"
          :parseTimeRange="parseTimeRange"
          :timeSelected="selectedtime"
          :buttonSelected="buttonSelected"
          @activeBanner="(activeBanner = true), (key = !key)"
          @successMsg="successMsg = $event"
          @success="isSuccess = $event"
          urlType="queue"
        />

        <div class="" v-if="tableData?.length || tableDataConcatenated?.length">
          <div class="overflow-hidden border-gray-200 rounded-md">
            <FullReportTableUsers
              :groupData="groupData"
              :currentSortDir="currentSortDir"
              :tableData="filteredData"
              :header="tableHeader"
              :body="tableBody"
              :selectedtime="selectedtime"
              :extensionsArray="extensionsArray"
              v-model:searchExtension="searchExtension"
              :period="period"
              :parseDateRange="parseDateRange"
              :queuesOnlyStats="queuesOnlyStats"
              :timeRange="timeRange"
              :timeGap="timeGap"
              :numberOfColumns="numberOfColumns"
              :selectedRangeType="selectedRangeType"
              :extensionsNameNumberArray="extensionsNameNumberArray"
              @sort="sort($event)"
            />
          </div>
        </div>

        <div v-else class="mt-8 overflow-x-auto sm:-mx-6 lg:-mx-0">
          <div
            v-if="!this.pbxElements || this.pbxElements.length <= 0"
            class="text-center max-w-lg mx-auto space-y-4"
          >
            <font-awesome-icon
              icon="chart-column"
              class="mx-auto h-10 w-10 text-teal-600"
              aria-hidden="true"
            />
            <h1 class="text-gray-900 font-bold text-2xl">
              Analysez la performance des agents.
            </h1>
            <h3 class="mt-2 text-lg font-medium text-gray-900">
              Suivi des activités des agents par jour : temps de connexion et de
              déconnexion, temps passé sur différents statuts.
            </h3>
            <div class="pt-10">
              <PleaseSelectElement
                dataDescription="Veuillez sélectionner un utilisateur et une période"
              />
            </div>
          </div>
          <div
            v-else
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-6"
          >
            <div class="overflow-hidden border-b border-gray-200 rounded-md">
              <NoData />
            </div>
          </div>
        </div>
      </template>
    </ExpertStatisticsTemplate>
  </div>
</template>

<script>
import PleaseSelectElement from "../../components/PleaseSelectElement.vue";
import PopupShareReport from "../../components/PBX/PopupShareReport.vue";
import HoverDatePicker from "../../components/PBX/HoverDatePicker.vue";
import ExpertStatisticsTemplate from "./ExpertStatisticsTemplate.vue";
import Tooltip from "../../components/Collect/formTools/Tooltip.vue";
import axios from "axios";
import { mapGetters } from "vuex";

import "vue-loading-overlay/dist/vue-loading.css";
import SuccessBanner from "../../components/SuccessBanner.vue";
import PbxHeader from "../../components/PBX/PbxHeader.vue";
import PbxDashboardSelector from "../../components/PBX/PbxDashboardSelector.vue";
import FullReportTableUsers from "../../components/PBX/FullReportTableUsers.vue";
import {
  Switch,
  SwitchGroup,
  SwitchLabel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import { ChevronDownIcon, XIcon } from "@heroicons/vue/outline";
import {
  ArrowCircleRightIcon,
  ArrowCircleLeftIcon,
  InformationCircleIcon,
} from "@heroicons/vue/solid";

export default {
  props: ["urlType"],
  components: {
    PbxHeader,
    PbxDashboardSelector,
    SuccessBanner,
    FullReportTableUsers,
    Switch,
    SwitchGroup,
    SwitchLabel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronDownIcon,
    Tooltip,
    ArrowCircleRightIcon,
    ArrowCircleLeftIcon,
    InformationCircleIcon,
    XIcon,
    ExpertStatisticsTemplate,
    HoverDatePicker,
    PopupShareReport,
    PleaseSelectElement,
  },
  data() {
    return {
      currentSortDir: "asc",
      currentSort: "",
      selectedRangeType: "waiting",
      selectedRangeTypeText: "Durées d'attente",
      groupData: true,
      searchQueue: null,
      searchQueueName: null,
      searchExtension: null,
      searchExtensionName: null,
      queuesNameArray: [],
      queuesArray: [],
      extensionsNameArray: [],
      extensionsNameNumberArray: [],
      queuesNameNumberArray: [],
      extensionsArray: [],
      queuesOnlyStats: true,
      data: {},
      selectedtime: undefined,
      fullPage: true,
      selectedElement: "",
      selectedQueue: "",
      period: "",
      selectHostname: "",
      queueData: [],
      extensionData: [],
      textMonth: "",
      buttonSelected: "month",
      successMsg: "",
      activeBanner: false,
      isSuccess: true,
      key: false,
      concatenateData: false,
      startDate: null,
      endDate: null,
      tableDataConcatenated: null,
      tableData: null,
      tableHeader: null,
      tableBody: null,
    };
  },
  methods: {
    setPeriod(...args) {
      this.startDate = args[0];
      this.endDate = args[1];

      //  let flag = false;
      //  if (this.concatenateData) {
      //   flag = true;
      //   this.concatenateData = false;
      //  }
      this.setTableData();
      //  if (flag) this.concatenateData = true;
    },
    async getData(retryCount = 0) {
      const MAX_RETRIES = 5; // Maximum number of retries
      const RETRY_DELAY_MS = 1000; // 2 seconds delay between retries

      let arrayOfElements = [];
      let stringOfElements = "";

      if (
        this.pbxElements &&
        this.pbxElements.length > 0 &&
        this.startDate &&
        this.endDate
      ) {
        this.pbxElements.forEach((element, index) => {
          let elementValue = element;
          if (typeof elementValue === "object") {
            for (let i = 0; i < elementValue.length; i++) {
              const el = elementValue[i];
              arrayOfElements.push(el);
            }
          } else {
            arrayOfElements.push(element);
          }
        });

        arrayOfElements = [...new Set(arrayOfElements)];

        // Handle case where arrayOfElements might be empty after processing
        if (arrayOfElements.length === 0) {
          console.warn("No elements to fetch data for. Skipping API call.");
          return null; // Or handle this case as appropriate for your app
        }

        stringOfElements = String(arrayOfElements[0]);

        for (let index = 1; index < arrayOfElements.length; index++) {
          stringOfElements =
            stringOfElements + "," + String(arrayOfElements[index]);
        }

        let url = `${this.$cookie.getCookie("API")}/api/v1.2/agent-stats/${
          this.hostName
        }/daily-activity?start_date=${this.startDate}&end_date=${
          this.endDate
        }&user_dns=${stringOfElements}`;

        try {
          const res = await axios.get(url, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });

          // Check if the data is "empty" or not what you expect
          // You'll need to define what "empty" means for your data.
          // For example, if res.data is an empty array or an object with no keys:
          if (
            !res.data ||
            !res.data?.data
              .length /* Add more specific checks for your data structure */
          ) {
            console.log("error data empty");
            if (retryCount < MAX_RETRIES) {
              console.warn(
                `Data is empty or incomplete. Retrying in ${
                  RETRY_DELAY_MS / 1000
                } seconds... (Attempt ${retryCount + 1}/${MAX_RETRIES})`,
              );
              await new Promise((resolve) =>
                setTimeout(resolve, RETRY_DELAY_MS),
              );
              return this.getData(retryCount + 1); // Recursive call with incremented retryCount
            } else {
              console.error(
                `Max retries (${MAX_RETRIES}) reached. Data still empty or incomplete.`,
              );
              // throw an error or return a specific value to indicate failure
              this.errorHandling(
                new Error(
                  "Failed to retrieve complete data after multiple attempts.",
                ),
              );
              return null; // Or an empty data structure
            }
          }

          return res.data;
        } catch (error) {
          // Check if the error is due to a network issue or server unavailability
          // For some HTTP errors (e.g., 500, 503, 408) it might make sense to retry.
          // For others (e.g., 401 Unauthorized, 404 Not Found), retrying might not help.
          if (
            error.response &&
            (error.response.status === 500 ||
              error.response.status === 503 ||
              error.response.status === 408)
          ) {
            if (retryCount < MAX_RETRIES) {
              console.warn(
                `API error (${error.response.status}). Retrying in ${
                  RETRY_DELAY_MS / 1000
                } seconds... (Attempt ${retryCount + 1}/${MAX_RETRIES})`,
              );
              await new Promise((resolve) =>
                setTimeout(resolve, RETRY_DELAY_MS),
              );
              return this.getData(retryCount + 1);
            } else {
              console.error(
                `Max retries (${MAX_RETRIES}) reached. API error still present.`,
              );
              this.errorHandling(error);
              return null;
            }
          } else {
            // For other errors, just handle them normally
            this.errorHandling(error);
            return null;
          }
        }
      }
      // If initial conditions (this.pbxElements, etc.) are not met
      console.warn("Initial conditions for fetching data not met.");
      return null;
    },
    async setTableData() {
      this.tableData = [];
      this.tableDataConcatenated = [];
      this.$emit("setLoading", true);
      this.$store.dispatch("pbxElementType", this.urlType);
      let raw = [];
      try {
        raw = await this.getData();
        if (raw && raw?.data.length) {
          // Process your data here, it's now guaranteed (or retried multiple times) to be available
          console.log("Data successfully fetched:", raw);
        } else {
          console.warn("Could not retrieve data after multiple attempts.");
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        // Handle the error in your UI (e.g., show an error message)
      }
      const data = raw?.data || [];
      // console.log("data ==> ", data);

      // Update table headers for daily activity view
      this.tableHeader = [
        { text: "Utilisateur", info: "", hasInfo: false, key: "user" },
        { text: "Date", hasInfo: false, key: "date" },
        { text: "Début Connexion", hasInfo: false },
        { text: "Fin Connexion", hasInfo: false },
        { text: "Durée Connexion", hasInfo: false },
        { text: "Disponible", hasInfo: false },
        { text: "Absent", hasInfo: false },
        { text: "NPD", hasInfo: false },
        { text: "Custom", hasInfo: false },
        {
          text: "Disponibilité (%)",
          hasInfo: false,
        },
      ];

      this.tableBody = [
        "user",
        "date",
        "login_time",
        "logout_time",
        "session_duration",
        "available_time",
        "away_time",
        "dnd_time",
        "break_time",
        "availability_percentage",
      ];

      if (data?.length) {
        const formattedData = [];

        // Process each user and their daily activities
        data.forEach((userEntry) => {
          const userName =
            userEntry.user_dn +
            (this.pbxMap &&
            this.pbxMap["extensions"] &&
            this.pbxMap["extensions"][userEntry.user_dn]
              ? "-" + this.pbxMap["extensions"][userEntry.user_dn]
              : "");

          if (this.selectedElement && userName) {
            this.selectedElement = this.selectedElement?.map((res) => {
              if (res === userName.split("-")[0]) {
                return userName;
              } else {
                return res;
              }
            });
          }

          // Create a row for each day of activity
          userEntry.daily_activity?.forEach((dayActivity) => {
            // Process status breakdown for this day
            let availableMinutes = 0;
            let awayMinutes = 0;
            let dndMinutes = 0;
            let breakMinutes = 0;
            let otherMinutes = 0;

            dayActivity.status_breakdown?.forEach((status) => {
              switch (status.status) {
                case 0: // Available
                  availableMinutes += status.total_minutes || 0;
                  break;
                case 1: // Custom 1 (usually break/pause repas)
                  breakMinutes += status.total_minutes || 0;
                  break;
                case 2: // Custom 2
                  otherMinutes += status.total_minutes || 0;
                  break;
                case 3: // Do not disturb
                case 9: // DND
                  dndMinutes += status.total_minutes || 0;
                  break;
                case 4: // Away
                  awayMinutes += status.total_minutes || 0;
                  break;
                default:
                  otherMinutes += status.total_minutes || 0;
              }
            });

            // Calculate availability percentage for this day
            const totalActiveMinutes =
              availableMinutes +
              awayMinutes +
              dndMinutes +
              breakMinutes +
              otherMinutes;
            const availabilityPercentage =
              totalActiveMinutes > 0
                ? ((availableMinutes / totalActiveMinutes) * 100).toFixed(2)
                : "0.00";

            const dayRow = {
              user: userName,
              date: dayActivity.date || "N/A",
              login_time: dayActivity.login_time || "N/A",
              logout_time: dayActivity.logout_time || "N/A",
              //  session_duration: dayActivity.session_duration_formatted || "00:00",
              session_duration:
                this.formatMinutesToHours(totalActiveMinutes) || "00:00",
              available_time: this.formatMinutesToHours(availableMinutes),
              away_time: this.formatMinutesToHours(awayMinutes),
              dnd_time: this.formatMinutesToHours(dndMinutes),
              break_time: this.formatMinutesToHours(breakMinutes),
              availability_percentage: availabilityPercentage + "%",
              // Store raw data for consolidation
              //  _raw_session_minutes: dayActivity.session_duration_minutes || 0,
              //  _raw_available_minutes: availableMinutes,
              //  _raw_away_minutes: awayMinutes,
              //  _raw_dnd_minutes: dndMinutes,
              //  _raw_break_minutes: breakMinutes,
            };

            formattedData.push(dayRow);
          });
        });

        this.tableData = formattedData;
        // this.tableDataConcatenated[0] = this.consolidateData(
        //  formattedData,
        //  raw?.period_info
        // );
        this.extensionsNameNumberArray = [
          ...new Set(formattedData.map((res) => res.user)),
        ];
      }

      this.$emit("setLoading", false);
    },
    consolidateData(data, periodInfo) {
      const consolidated = {
        user: "Total - Tous les Utilisateurs",
        date: "Période Complète",
        login_time: "-",
        logout_time: "-",
        total_session_minutes: 0,
        total_available_minutes: 0,
        total_away_minutes: 0,
        total_dnd_minutes: 0,
        total_break_minutes: 0,
        total_days: 0,
      };

      data.forEach((row) => {
        consolidated.total_session_minutes += row._raw_session_minutes || 0;
        consolidated.total_available_minutes += row._raw_available_minutes || 0;
        consolidated.total_away_minutes += row._raw_away_minutes || 0;
        consolidated.total_dnd_minutes += row._raw_dnd_minutes || 0;
        consolidated.total_break_minutes += row._raw_break_minutes || 0;
        consolidated.total_days += 1;
      });

      // Calculate overall availability percentage
      const totalActiveMinutes =
        consolidated.total_available_minutes +
        consolidated.total_away_minutes +
        consolidated.total_dnd_minutes +
        consolidated.total_break_minutes;

      const availabilityPercentage =
        totalActiveMinutes > 0
          ? (
              (consolidated.total_available_minutes / totalActiveMinutes) *
              100
            ).toFixed(2)
          : "0.00";

      return {
        user: consolidated.user,
        date: periodInfo
          ? `${periodInfo.start_date} à ${periodInfo.end_date} (${consolidated.total_days} jours)`
          : `${consolidated.total_days} jours`,
        login_time: "-",
        logout_time: "-",
        session_duration: this.formatMinutesToHours(
          consolidated.total_session_minutes,
        ),
        available_time: this.formatMinutesToHours(
          consolidated.total_available_minutes,
        ),
        away_time: this.formatMinutesToHours(consolidated.total_away_minutes),
        dnd_time: this.formatMinutesToHours(consolidated.total_dnd_minutes),
        break_time: this.formatMinutesToHours(consolidated.total_break_minutes),
        availability_percentage: availabilityPercentage + "%",
      };
    },
    formatMinutesToHours(totalMinutes) {
      if (!totalMinutes || totalMinutes === 0) return "00:00";

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0",
      )}`;
    },
    parseTimeToMinutes(timeString) {
      if (!timeString || timeString === "00:00") return 0;

      const [hours, minutes] = timeString
        .split(":")
        .map((n) => parseInt(n, 10) || 0);
      return hours * 60 + minutes;
    },
    async downloadReport() {
      let arrayOfElements = [];
      let stringOfElements = "";
      if (
        this.pbxElements &&
        this.pbxElements.length > 0 &&
        this.startDate &&
        this.endDate
      ) {
        this.$emit("setLoading", true);
        this.pbxElements.forEach((element, index) => {
          let elementValue = element;
          if (typeof elementValue === "object") {
            for (let index = 0; index < elementValue.length; index++) {
              const element = elementValue[index];
              arrayOfElements.push(element);
            }
          } else {
            arrayOfElements.push(element);
          }
        });

        arrayOfElements = [...new Set(arrayOfElements)];

        stringOfElements = String(arrayOfElements[0]);

        for (let index = 1; index < arrayOfElements.length; index++) {
          stringOfElements =
            stringOfElements + "," + String(arrayOfElements[index]);
        }
        const params = {
          start_date: this.startDate,
          end_date: this.endDate,
          dn: stringOfElements, // Replace with your DID number or dynamic value
          start_time: this.pbxTimeSelected[0], // Optional, adjust as necessary
          end_time: this.pbxTimeSelected[1], // Optional, adjust as necessary
        };
        let url = `${this.$cookie.getCookie("API")}/api/v1.2/${
          this.hostName
        }/users-report-file`;
        try {
          const res = await axios.post(url, params, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            responseType: "blob",
          });
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // Set the filename
          const reportDate = `${params.start_date}_to_${params.end_date}`;
          link.download = `Users_Report_${reportDate}.xlsx`;

          // Trigger the download
          link.click();
          window.URL.revokeObjectURL(link.href);
        } catch (error) {
          this.errorHandling(error);
        }
      }
      if (!this.pbxElements || this.pbxElements.length == 0) {
        this.$emit("activeBanner");
        this.$emit("success", false);
        this.$emit(
          "successMsg",
          "Veuillez sélectionner un ou plusieurs numéros",
        );
      }
      this.$emit("setLoading", false);
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },
    sortedData() {
      const extensionData = this.tableData;
      let extensionDataSorted = extensionData.sort((a, b) => {
        let toBeSorted = this.currentSort;
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        if (parseInt(a[toBeSorted]) < parseInt(b[toBeSorted]))
          return -1 * modifier;
        if (parseInt(a[toBeSorted]) > parseInt(b[toBeSorted]))
          return 1 * modifier;
        return 0;
      });
      return extensionDataSorted;
    },
    parseDateRange(date) {
      if (date.length === 8) {
        let year = ("0" + date).slice(1, -4);
        let month = ("0" + date).slice(-4, -2);
        let day = ("0" + date).slice(-2);
        let fullDay = "";
        fullDay = day + "/" + month + "/" + year;
        return String(fullDay);
      } else if (date.length === 6) {
        let year = ("0" + date).slice(1, 5);
        let month = ("0" + date).slice(-2);
        let fullDay = "";
        fullDay = month + "/" + year;
        return String(fullDay);
      } else if (date.length === 17) {
        let fullDay = date.split("-");
        let firstYear = ("0" + fullDay[0]).slice(1, 5);
        let firstMonth = ("0" + fullDay[0]).slice(-4, -2);
        let firstDay = ("0" + fullDay[0]).slice(-2);

        let firstFullDay = "";
        firstFullDay = firstDay + "/" + firstMonth + "/" + firstYear;

        let lastYear = ("0" + fullDay[1]).slice(1, 5);
        let lastMonth = ("0" + fullDay[1]).slice(-4, -2);
        let lastDay = ("0" + fullDay[1]).slice(-2);

        let lastFullDay = "";
        lastFullDay = lastDay + "/" + lastMonth + "/" + lastYear;
        let finalDay = "";
        finalDay = firstFullDay + " - " + lastFullDay;
        return String(finalDay);
      } else {
        return date;
      }
    },
    parseTimeRange(time) {
      if (time && time.length > 0) {
        const timeStart = time[0].slice(0, 2) + ":" + time[0].slice(2);
        const timeEnd = time[1].slice(0, 2) + ":" + time[1].slice(2);
        const finalTime = timeStart + " - " + timeEnd;
        return String(finalTime);
      }
    },
  },
  watch: {
    selectedtime: function (val) {
      //  let flag = false;
      //  if (this.concatenateData) {
      //   flag = true;
      //   this.concatenateData = false;
      //  }
      //  if (flag) this.concatenateData = true;
    },
    urlType: function (val) {
      this.$store.dispatch("pbxElements", null);
    },
    concatenateData: function (val) {
      //  this.setTableData();
    },
  },
  mounted() {
    if (this.pbxElements) {
      this.selectedElement = this.pbxElements;

      if (this.pbxElementType !== this.urlType)
        this.$store.dispatch("pbxElements", null);
    }
  },
  computed: {
    filteredData() {
      return this.sortedData().filter((data) => {
        if (this.searchExtension?.length > 0) {
          let flag = false;
          this.searchExtension.forEach((user) => {
            if (user.includes(data.user)) {
              flag = true;
            }
          });
          return flag;
        }
        return data;
      });
    },
    ...mapGetters([
      "hostName",
      "hostTimeZone",
      "pbxPeriodSelected",
      "pbxElements",
      "pbxMap",
      "pbxElementType",
      "pbx3cxTableConfig",
      "pbxTimeSelected",
    ]),
  },
};
</script>

<style>
.switch-group {
  position: absolute;
  right: 1.3rem;
  top: 23.5rem;
}
.switch-group-no-info {
  position: absolute;
  right: 1.3rem;
  top: 18.5rem;
}
</style>
